import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.switchChain = void 0;
  const toHex_js_1 = _toHexDew();
  async function switchChain(client, {
    id
  }) {
    await client.request({
      method: "wallet_switchEthereumChain",
      params: [{
        chainId: (0, toHex_js_1.numberToHex)(id)
      }]
    });
  }
  exports.switchChain = switchChain;
  //# sourceMappingURL=switchChain.js.map
  return exports;
}